module.exports = __webpack_public_path__ + "img/szegyenlos_lanyok_6.332b7494.jpg";